export default "__VITE_ASSET__c71c8aa9__"